module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.back($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tInvoices\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": _vm.back
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), (!_vm.isLoading) ? _c('v-layout', {
    staticClass: "modal__section",
    attrs: {
      "align-space-around": "",
      "justify-center": "",
      "column": "",
      "fill-height": ""
    }
  }, _vm._l((_vm.invoices), function(invoice) {
    return _c('v-layout', {
      key: invoice.id,
      staticClass: "invoice",
      attrs: {
        "align-center": "",
        "justify-space-between": ""
      }
    }, [_c('div', [_vm._v(_vm._s(_vm._f("timeConverter")(invoice.date)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(invoice.amount) + " " + _vm._s(invoice.currency))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.downloadInvoice(invoice.id)
        }
      }
    }, [_vm._v("Download")])])
  }), 1) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16bc798a","hasScoped":false}!./app/components/account-invoices-modal/template.html
// module id = 371
// module chunks = 0